// extracted by mini-css-extract-plugin
export default {"parallax1":"Home_parallax1__Oii69","parallax1Buttons":"Home_parallax1Buttons__y-dl-","videoIFrame":"Home_videoIFrame__8ysT4"};